import { RiskAssessmentFrequency, RiskRatingSource } from '@gcv/shared';

import palette from 'ui/theme/palette';
import { ExtendedRiskRatingSource } from './enums';

/** Small uppercase label above a card's headline value. */
export const SECTION_LABEL_SX = {
  fontSize: '0.6875rem',
  fontWeight: 600,
  letterSpacing: '0.06em',
  color: palette.text.secondary
};

export const RISK_RATING_SOURCE_LABELS: {
  [source in RiskRatingSource | ExtendedRiskRatingSource]: string;
} = {
  [RiskRatingSource.RiskAssessment]: 'Risk Assessment',
  [RiskRatingSource.MonitoringReview]: 'Monitoring Review',
  [RiskRatingSource.ManualOverride]: 'Manual override',
  [RiskRatingSource.OverrideRemoved]: 'Override removed',
  [RiskRatingSource.Rollup]: 'Calculated Average',
  [RiskRatingSource.Manual]: 'Set manually',
  [RiskRatingSource.AccountApproval]: 'Account Approval',
  [ExtendedRiskRatingSource.BandChange]: 'Band Change',
  [ExtendedRiskRatingSource.Seeded]: 'Initial Rating'
};

export const RISK_ASSESSMENT_FREQUENCY_LABELS: { [frequency in RiskAssessmentFrequency]: string } = {
  [RiskAssessmentFrequency.OneTime]: 'One time',
  [RiskAssessmentFrequency.Quarterly]: 'Quarterly',
  [RiskAssessmentFrequency.SemiAnnually]: 'Semi-annually',
  [RiskAssessmentFrequency.Annually]: 'Annually'
};
